import { useContext } from "react"
import FormContext from "../FormContext"

const useGetFormContext = () => {
    return useContext(FormContext)
}

export default useGetFormContext